import React from 'react'
import useCustomisation from 'src/hooks/useCustomisation'

export const useProductImageState = (): {
  showImage: boolean
  listView: boolean
  showDefaultImage: boolean
  productImageAspect: string
  isTopNavLayout: boolean
} => {
  const { getLastSectionFromType } = useCustomisation()
  const { settings = {} } = React.useMemo(
    () => getLastSectionFromType('products'),
    [getLastSectionFromType]
  )
  return React.useMemo(() => {
    const showImage = settings.showProductImage === true
    const listView = settings.productLayout === 'list'
    const showDefaultImage =
      !listView || (listView && !!settings.showDefaultImage)
    const productImageAspect = settings.productImageAspect || 'cover'
    const isTopNavLayout = settings.productCategoryLayout === 'top'
    return {
      showImage,
      listView,
      showDefaultImage,
      productImageAspect,
      isTopNavLayout
    }
  }, [settings])
}

const ProductImageState = ({ children }: { children }): JSX.Element =>
  children(useProductImageState())

export default ProductImageState
